import Vue from "vue";
import { alertasMixin } from "@/common/mixins/AlertasMixin";
import { TipoErro, ehErroSistemico } from "./catalogo";
import {
  mensagensCitamCodigo,
  textoCodigoSuporte,
  textoDoErro,
} from "./erro.service";
import { opcoesToastErro } from "./toast.options";

const escapar = (texto) =>
  String(texto).replace(/[&<>"']/g, (c) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  }[c]));

/**
 * Único lugar que decide COMO um erro já interpretado aparece. Usado pelo
 * ApiService (que não tem componente) e pelo ErroMixin.
 *
 * - Erro que o usuário resolve (validação, negócio, não encontrado, conflito):
 *   toast de 8s -- ele corrige ali mesmo, e o campo culpado fica em vermelho.
 * - Erro que ele não resolve (sistêmico, indisponível, rede): modal, que não
 *   some sozinho, com o código de suporte quando o servidor mandou.
 *
 * @param {Object} erro resultado de interpretarErro()
 * @param {Object} [opcoes]
 * @param {boolean} [opcoes.emModal] falha do usuário também em modal (aviso).
 *   Para telas em que o toast pode passar despercebido -- ex.: recusa do
 *   cartão na tela do pagador.
 */
export function apresentarErro(erro, opcoes = {}) {
  if (!erro || erro.tipo === TipoErro.CANCELADO) return;

  if (ehErroSistemico(erro.tipo)) {
    const corpo = escapar(erro.mensagens.join(" "));
    const codigo =
      erro.codigoSuporte &&
      !mensagensCitamCodigo(erro.mensagens, erro.codigoSuporte)
        ? `<br><br><small>${escapar(textoCodigoSuporte(erro.codigoSuporte))}</small>`
        : "";

    alertasMixin.fire({
      title: erro.titulo || undefined,
      html: corpo + codigo,
      icon: "error",
      confirmButtonText: "Ok",
    });
    return;
  }

  if (opcoes.emModal) {
    alertasMixin.fire({
      title: erro.titulo || undefined,
      text: textoDoErro(erro),
      icon: "warning",
      confirmButtonText: "Ok",
    });
    return;
  }

  Vue.$toast.error(textoDoErro(erro), opcoesToastErro());
}
